import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Badge } from '../components/ui/badge';

export function CarCard({ car }) {
  const { t } = useLanguage();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(price);
  };

  const formatMileage = (mileage) => {
    return new Intl.NumberFormat('en-US').format(mileage);
  };

  return (
      <Link
        to={`/inventory/${car.id}`}
        data-testid={`car-card-${car.stock_number}`}
        className="group block relative overflow-hidden bg-[#121212] border border-zinc-800/50 rounded-md hover:border-[#ED2227]/30 transition-all duration-300"
      >
        {/* Image */}
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={car.images?.[0] || 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600'}
            alt={`${car.make} ${car.model}`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

          {/* Badges */}
          <div className="absolute top-3 left-3 flex gap-2">
            {car.featured && (
              <Badge className="bg-[#ED2227] text-white text-[10px] tracking-widest uppercase border-0 rounded-sm px-2 py-1">
                {t('inventory.featured')}
              </Badge>
            )}
            <Badge className="bg-black/60 backdrop-blur-sm text-white text-[10px] tracking-widest uppercase border-0 rounded-sm px-2 py-1">
              {car.condition === 'New' ? t('inventory.filterNew') : t('inventory.filterUsed')}
            </Badge>
          </div>

          {/* Stock Number */}
          <div className="absolute top-3 right-3">
            <span className="text-[10px] font-mono tracking-wider text-white/60 bg-black/40 backdrop-blur-sm px-2 py-1 rounded-sm">
              {car.stock_number}
            </span>
          </div>
        </div>

        {/* Info */}
        <div className="p-4 space-y-3">
          <div>
            <h3 className="text-white font-bold text-base font-[Chivo] tracking-tight">
              {car.make} {car.model}
            </h3>
          </div>

          <div className="grid grid-cols-3 gap-2 pt-2 border-t border-white/5">
            <div>
              <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-600 block">
                {t('inventory.year')}
              </span>
              <span className="text-sm text-white font-medium">{car.year}</span>
            </div>
            <div>
              <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-600 block">
                {t('inventory.mileage')}
              </span>
              <span className="text-sm text-white font-medium">{formatMileage(car.mileage)} km</span>
            </div>
            <div className="text-right">
              <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-600 block">
                {t('inventory.price')}
              </span>
              <span className="text-sm text-[#ED2227] font-bold">{formatPrice(car.price)}</span>
            </div>
          </div>
        </div>
      </Link>
  );
}
